import { SvgIcon, SvgIconProps } from '@mui/material'

const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.5 19.3099L17.1056 14.9155C18.0352 13.6479 18.5423 12.1268 18.5423 10.5211C18.5423 6.38028 15.162 3 11.0211 3C6.88028 3 3.5 6.38028 3.5 10.5211C3.5 14.662 6.88028 18.0423 11.0211 18.0423C12.7113 18.0423 14.2324 17.5352 15.4155 16.6056L19.8099 21L21.5 19.3099ZM11.0211 15.6761C8.14789 15.6761 5.8662 13.3944 5.8662 10.5211C5.8662 7.64789 8.14789 5.3662 11.0211 5.3662C13.8944 5.3662 16.1761 7.64789 16.1761 10.5211C16.1761 13.3944 13.8944 15.6761 11.0211 15.6761Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default SearchIcon
